import { useState } from "react";
import { skipToken } from "@reduxjs/toolkit/query";
import { usePostMultiplacerDrofusInterfaceOccurrenceByIfcGuidQuery, usePostMultiplacerDrofusInterfaceOccurrencesInRoomQuery } from "../../openapi";
import { useAppSelector } from "../app/hooks";
import { DrofusForekomstDetailsModal } from "../DrofusForekomster/DrofusForekomstDetailsModal";
import { selectDrofusMatchContextKey, selectDrofusMatchGuidArg, selectDrofusMatchRoomArg, selectDrofusMatchView } from "../drofusSelectors";
import { selectDrofusMatchDetailsSnapshot, type DrofusMatchSelection } from "../drofusSelectors";
import styles from "./DrofusMatch.module.css";

export function DrofusMatch() {
  const contextKey = useAppSelector(selectDrofusMatchContextKey);
  return <DrofusMatchContent key={contextKey} />;
}

function DrofusMatchContent() {
  const [selected, setSelected] = useState<DrofusMatchSelection>(null);
  const guidArg = useAppSelector(selectDrofusMatchGuidArg);
  const roomArg = useAppSelector(selectDrofusMatchRoomArg);
  const guidQuery = usePostMultiplacerDrofusInterfaceOccurrenceByIfcGuidQuery(guidArg ?? skipToken, { refetchOnMountOrArgChange: true });
  const roomQuery = usePostMultiplacerDrofusInterfaceOccurrencesInRoomQuery(roomArg ?? skipToken, { refetchOnMountOrArgChange: true });
  const view = useAppSelector(selectDrofusMatchView);
  const detailsSnapshot = useAppSelector(state => selectDrofusMatchDetailsSnapshot(state, selected));

  return <>
    <details className={`${styles.section} ${view.rows.length > 0 ? styles.hasMatches : ""}`} open>
      <summary>Drofus match</summary>
      <div className={styles.content}>
        {view.heading && <h4 className={styles.heading}>{view.heading}</h4>}
        {view.message && <p role="status">{view.message}</p>}
        {view.retry && <button className={styles.link} type="button" onClick={() => view.retry === "guid" ? guidQuery.refetch() : roomQuery.refetch()}>Prøv igjen</button>}
        {view.rows.map(row => <dl className={styles.row} key={`${row.runId}:${row.occurrenceId}`}>
          <dt>Forekomst-ID</dt>
          <dd><button className={styles.link} type="button" onClick={() => setSelected({ occurrenceId: row.occurrenceId, runId: row.runId })} aria-label={`Åpne dRofus-forekomst ${row.occurrenceId}`}>{row.occurrenceId}</button></dd>
          <dt>Antall</dt><dd>{row.quantity ?? "—"}</dd>
        </dl>)}
      </div>
    </details>
    {detailsSnapshot && <DrofusForekomstDetailsModal occurrenceRef={detailsSnapshot} snapshot={detailsSnapshot} opened onClose={() => setSelected(null)} />}
  </>;
}
